import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { IPageBase, PagesState } from 'store/pages/types';

export const getPagesState = (state: RootState): PagesState => state.pages;

export const getAllPages = createSelector([getPagesState], (state: PagesState): IPageBase[] =>
  state?.data?.pages?.map(page => ({
    ...page,
    donation_amounts: Array.isArray(page.donation_amounts)
      ? page.donation_amounts.map(amount => amount / 100)
      : page.donation_amounts,
  }))
);
